import React, { useContext } from "react";
import ContentData from "../../../../constants/contentFile.json";
import NextIcon from "../../../../assets/images/next-icon.svg";
import EditIcon from "../../../../assets/images/edit-icon.svg";
import { Container } from "react-bootstrap";
import { ProfileManageContext } from "../ProfileInfoView";
import ProfileIcon from "../../../../assets/images/icons/profile-icon.svg";
import ThemeButton from "../../../../components/ThemeButton/ThemeButton";
import CheckBox from "../../../../components/CheckBoxComponent/CheckBox";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./profileInfo.css";
import routeConstants from "../../../../constants/routeConstants.json";
import Loader from "../../../../components/Loader/Loader";
import { useNavigate } from "react-router-dom";
import ErrorPopup from "../../../../components/PopupAlertError/PopupAlertError";

const ProfileInfo = () => {
  const navigate = useNavigate();
  const {
    name,
    email,
    phoneNumber,
    role,
    fullImageUrl,
    spinnerStatus,
    mfa,
    errorPopup,
    setErrorPopup,
    errorPopupMessage,
    buttonText,
    roleToLogin,
    statusValue,
    getUserDetails,
  } = useContext(ProfileManageContext);
  return (
    <div className="pageBg">
      <div className="breadCrums boldBreadCrums">
        {ContentData.profilePage.pageTitle}
      </div>

      {spinnerStatus && <Loader />}

      <Container className="profileInfoContainer">
        <div className="profilePageTitleBar">
          <div className="pageTittles-profileInfoContainer">
            {ContentData.profilePage.profile}
          </div>

          <div className="pageTitleButtons">
            <ThemeButton
              value={ContentData.profilePage.changePassword}
              className="changePassword"
              // className={ChangePassword} onClick={} type={button}
              onClick={() => {
                navigate(routeConstants.CHANGE_PASSWORD);
              }}
            />
            <ThemeButton
              className="editIcon"
              onClick={() => {
                navigate(routeConstants.EDIT_PROFILE);
              }}
              value={
                <img className="editIcon" src={EditIcon} alt="edit icon" />
              }
            />
          </div>
        </div>
        <div className="profilePicAndDetails">
          <div className="profileImage">
            <div className="avatar">
              {fullImageUrl ? (
                <img
                  className="profileIcon"
                  src={fullImageUrl}
                  alt="Profile Icon"
                />
              ) : (
                <img
                  className="profileIcon"
                  src={ProfileIcon}
                  alt="Profile Icon"
                />
              )}
              {/* <img
                className="profileIcon"
                src={ProfileIcon}
                alt="Profile Icon"
              /> */}
            </div>
          </div>
          <div className="profileDetails">
            <div className="profileDetails-row1">
              <div className="">
                <div className="profileDetailsDataTitle">
                  {ContentData.profilePage.name}
                </div>
                <div className="profileDetailsData">{name}</div>
              </div>
              <div className="">
                <div className="profileDetailsDataTitle">
                  {ContentData.profilePage.emailAddress}
                </div>
                <div className="profileDetailsData">{email}</div>
              </div>
              <div className="">
                <div className="profileDetailsDataTitle">
                  {ContentData.profilePage.phoneNumber}
                </div>
                <div className="profileDetailsData">
                  {phoneNumber ? phoneNumber : "Not added"}
                </div>
              </div>
            </div>
            <div className="profileDetails-row2">
              <div style={{ marginLeft: "2px" }}>
                <div className="profileDetailsDataTitle">
                  {ContentData.profilePage.role}
                </div>
                <div className="profileDetailsData">{role}</div>
              </div>
            </div>
          </div>
        </div>

        <div className="profileAccountSettings">
          <Accordion
            className="profileAccordion"
            disableGutters
            elevation={0}
            sx={{
              border: "none",
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header"
              sx={{
                fontSize: "12px",
                backgroundColor: "#F7F8FA",
                fontWeight: "bold",
                color: "#6b7a99",
              }}
            >
              {ContentData.profilePage.accountSettings}
            </AccordionSummary>

            <AccordionDetails sx={{ padding: 0 }}>
              <div className="accordionRowGroup">
                <div className="accordionRow">
                  <div className="rowTitle">
                    <CheckBox
                      label={ContentData.profilePage.multiFactorAuthentication}
                      id="multiFactor"
                      disabled={true}
                      check={mfa === "Email" || mfa === "App" || mfa === "Sms"}
                    />
                  </div>
                  <div className="rowData">
                    <CheckBox
                      label={ContentData.profilePage.email}
                      id="multiFactorEmail"
                      disabled={true}
                      check={mfa === "Email"}
                    />
                    <div style={{ marginLeft: "139px" }}>
                      <CheckBox
                        label={ContentData.profilePage.authenticationApp}
                        id="multiFactorAuthApp"
                        disabled={true}
                        check={mfa === "App"}
                      />
                    </div>
                    <div style={{ marginLeft: "139px" }}>
                      <CheckBox
                        label={ContentData.profilePage.sms}
                        id="Sms"
                        disabled={true}
                        check={mfa === "Sms"}
                      />
                    </div>
                  </div>
                  {/* {ContentData.profilePage.requestQrCode} */}
                </div>
              </div>
            </AccordionDetails>
          </Accordion>
        </div>
      </Container>

      <ErrorPopup
        show={errorPopup}
        alertMessage={errorPopupMessage}
        buttonText={buttonText}
        status={statusValue}
        handleCancel={() => setErrorPopup(false)}
        handleSubmit={() => {
          if (statusValue === 401 || statusValue === 403) {
            roleToLogin();
            setErrorPopup(false);
          } else {
            setErrorPopup(false);
            getUserDetails();
          }
        }}
        errorAlertOnly={statusValue === 400 ? true : false}
      />
    </div>
  );
};

export default ProfileInfo;
